import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OkCancelDialogActions } from '../../../../../../aumico-lib-core-fe/src/lib';

export type DeactivateFCPDialogData = {
    survey: string;
    action: OkCancelDialogActions;
};

@Component({
    selector: 'app-deactivate-fcp',
    templateUrl: './deactivate-fcp.component.html',
    styleUrls: ['./deactivate-fcp.component.scss'],
})
export class DeactivateFCPComponent implements OnInit {
    stopTrialForm: FormGroup;

    constructor(
        private readonly fb: FormBuilder,
        private readonly dialogRef: MatDialogRef<DeactivateFCPComponent, DeactivateFCPDialogData>,
        @Inject(MAT_DIALOG_DATA) public readonly endDate: Date,
    ) {}

    ngOnInit(): void {
        this.stopTrialForm = this.fb.group({
            survey: ['', Validators.required],
        });
    }

    stopFCP(): void {
        const { survey } = this.stopTrialForm.value;
        this.dialogRef.close({ survey, action: OkCancelDialogActions.OK });
    }

    closeDialog(): void {
        this.dialogRef.close();
    }
}
